<template lang="pug">
f7-page#reviews
  navbar(title="最近のレビュー" back)
  coach-query(
    :coachId="coachId"
    :after="nextCursor"
    ref="coachQuery"
    @nodata="hasMore = false")
    template(slot-scope="coach")
      .content
        review-list(:reviews="coach.coach.reviews" ref="reviewList")
        f7-link(
          v-if="hasMore"
          href="#"
          class="more-link"
          @click="onClickMore(coach.query)")
          | もっと見る
</template>

<style lang="scss" scoped>
#reviews {
  .more-link {
    display: block;
    text-align: center;
    margin-top: auto;
    margin-bottom: 16px;
    color: $color-primary;
  }
}
</style>

<script>
import ReviewList from '@/components/organisms/ReviewList'
import CoachQuery from '@/components/queries/CoachQuery'

export default {
  components: {
    ReviewList,
    CoachQuery,
  },
  data() {
    return {
      coachId: null,
      nextCursor: null,
      hasMore: true,
    }
  },
  methods: {
    async onClickMore(query) {
      await this.$refs.coachQuery.loadMore(query)
    },
  },
  created() {
    this.coachId = this.$f7route.params.id
  },
  mounted() {
    if (this.$f7route.params.reviewId) {
      const position = this.$refs.reviewList.reviewPositionBy(
        decodeURIComponent(this.$f7route.params.reviewId)
      )
      this.$nextTick(() => {
        this.$el.lastChild.scrollTo(0, position - 56)
      })
    }
  },
}
</script>
